/**
 * 表紙・特集商品選定依頼確認（グループ長用）画面の依頼クラス
 *
 * @export FeatureRequest
 * @class FeatureRequest
 */
export class FeatureRequest {
  constructor(
    public orderCode: string,
    public mediumType: string,
    public mediumTypeName: string,
    public featureGoodsRequestId: number,
    public requestStatus: number,
    public requestStatusName: string,
    public requestType: number,
    public requestTypeName: string,
    public featureCode: string,
    public featureName: string,
    public featureDisplay: string,
    public classCode: string,
    public classCodeName: string,
    public classDisplay: string,
    public middleClassCode: string,
    public middleClassCodeName: string,
    public middleClassDispaly: string,
    public pcode: string,
    public guideGoodsName: string,
    public guideStandardName: string,
    public tagName: string,
    public thisTimeSupplyPrice: number,
    public pricePattern: number,
    public pricePatternName: string,
    public planNumAiPrediction: number,
    public planNum: number,
    public planSupplyBudget: number,
    public dispPlanSupplyBudget: string,
    public thisTimeCostPrice: number,
    public gpr: number,
    public requestBuyerUserId: string,
    public requestBuyerUserName: string,
  ) {}
}
